export default __webpack_public_path__ + "static/media/dullpain.60a9c12e.png";